"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWixImageUrl = void 0;
var mediaSrcHandler_1 = require("santa-platform-utils/dist/esm/mediaSrcHandler/mediaSrcHandler");
var imageClientSDK_1 = require("@wix/image-client-api/dist/imageClientSDK");
function isMediaManagerImageSrc(mediaSrc) {
    return (mediaSrc.type === mediaSrcHandler_1.types.IMAGE &&
        'width' in mediaSrc &&
        typeof mediaSrc.width === 'number');
}
function getWixImageUrl(image, targetWidth, targetHeight) {
    if (!image) {
        return;
    }
    if ('src' in image) {
        var parsedMediaSrc = mediaSrcHandler_1.parseMediaSrc(image.src, mediaSrcHandler_1.types.IMAGE);
        if ('error' in parsedMediaSrc) {
            return;
        }
        if (isMediaManagerImageSrc(parsedMediaSrc)) {
            return getWixImageUrl({
                name: parsedMediaSrc.mediaId,
                width: parsedMediaSrc.width,
                height: parsedMediaSrc.height,
            }, targetWidth, targetHeight);
        }
        return parsedMediaSrc.mediaId;
    }
    if (!image.name) {
        return;
    }
    if (image.width && image.height) {
        targetHeight = (targetWidth / image.width) * image.height;
    }
    return imageClientSDK_1.getScaleToFillImageURL(image.name, image.width, image.height, targetWidth, targetHeight);
}
exports.getWixImageUrl = getWixImageUrl;
//# sourceMappingURL=getWixImageUrl.js.map